import {
    clearTimeouts,
    engine as anime,
} from "../../../../../animations/index";
import { getTemplateDurationOveride } from "../../../../shared/utils/timeline";
import _ from "lodash";

const timeouts = [];

const main = (props) => {
    const timeouts = [];
    const { id, format, templateName, data } = props;

    const timeline = anime.timeline();
    const templateDuration = 10;
    // getTemplateDurationOveride({
    //     apiSetup: props?.apiSetup,
    //     tournamentId: props?.data?.event?.competitionId,
    //     fallback:
    //         _.find(props?.data?.data?.options, { id: "videoduration" })?.value || 0,
    //     templateName,
    //     event: data?.event,
    // });

    $(`#${id} .ant-progress-bg`).css("width", "100%");
    $(`#${id} .ant-progress-bg`).css(
        "transition-duration",
        `${templateDuration}s`,
    );

    const page1Rows = $(`#${id} .page-1 .table-row`).get();
    page1Rows?.forEach((rowEl, index) => {
        const baseDelay = index * 100;
        anime({
            targets: $(rowEl).children().get(),
            duration: 800,
            easing: "easeOutQuint",
            opacity: [0, 1],
            delay: baseDelay + 100,
            complete: () => {
                anime({
                    targets: $(rowEl).children().get(),
                    duration: 800,
                    easing: "easeOutQuint",
                    opacity: [1, 0],
                    delay: baseDelay + 1000,
                });
            }
        });
    });

    const page2Rows = $(`#${id} .page-2 .table-row`).get();
    setTimeout(() => {
        page2Rows?.forEach((rowEl, index) => {
            const baseDelay = index * 100;
            anime({
                targets: $(rowEl).children().get(),
                duration: 800,
                easing: "easeOutQuint",
                opacity: [0, 1],
                delay: baseDelay + 100,
                complete: () => {
                    anime({
                        targets: $(rowEl).children().get(),
                        duration: 800,
                        easing: "easeOutQuint",
                        opacity: [1, 0],
                        delay: baseDelay + 1000,
                    });
                }
            });
        });
    }, 3000);


    const page3Rows = $(`#${id} .page-3 .table-row`).get();
    setTimeout(() => {
        page3Rows?.forEach((rowEl, index) => {
            const baseDelay = index * 100;
            anime({
                targets: $(rowEl).children().get(),
                duration: 800,
                easing: "easeOutQuint",
                opacity: [0, 1],
                delay: baseDelay + 100,
                complete: () => {
                    anime({
                        targets: $(rowEl).children().get(),
                        duration: 800,
                        easing: "easeOutQuint",
                        opacity: [1, 0],
                        delay: baseDelay + 1000,
                    });
                }
            });
        });
    }, 6000);

    const page4Rows = $(`#${id} .page-4 .table-row`).get();
    setTimeout(() => {
        page4Rows?.forEach((rowEl, index) => {
            const baseDelay = index * 100;
            anime({
                targets: $(rowEl).children().get(),
                duration: 800,
                easing: "easeOutQuint",
                opacity: [0, 1],
                delay: baseDelay + 1000,
                complete: () => {
                }
            });
        });
    }, 8000);

    return {
        timeline: [],
        timeouts,
    };
};

//clean up function, unmounting
export const animationCleanUp = (animationReturn) => {
    const { timeouts } = animationReturn;
    clearTimeouts(timeouts);
};

export default main;
